export default __webpack_public_path__ + "static/media/logo-new.2ff0cdbc.svg";